import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ConfirmActionComponent } from './confirm-action.component';
import { FormModule } from "../../default/form/form.module";
import { DirectivesModule } from "../../../directives/directives.module";

@NgModule({
	declarations: [ConfirmActionComponent],
	imports: [
		CommonModule,
		TranslateModule,
		FormModule,
		DirectivesModule,
	],
	exports: [ConfirmActionComponent]
})
export class ConfirmActionModule { }
